import React, { Component } from 'react';
import { Alert } from 'react-bootstrap';

class ErrorBoundarySmall extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        // You can also log the error to an error reporting service
        console.error("ErrorBoundary caught an error", error, errorInfo);
    }

    render() {
        if (this.state.hasError) {
            // You can render any custom fallback UI
            return (
                <Alert variant="danger">
                    Došlo k chybě. Zkuste prosím stránku znovu načíst nebo kontaktujte podporu.
                </Alert>
            );
        }

        return this.props.children; 
    }
}

export default ErrorBoundarySmall;
